<template>
  <div class="flex flex-col w-full">
    <card class="w-full flex flex-col mt-2 p-5">
      <div class="w-full gap-5 flex">
        <Card class="w-full">
          <div class="w-full flex justify-between items-center gap-2">
            <Card
              class="w-full bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
              style="box-shadow: -6px 9px 24px 0px #0000000f"
            >
              <div class="flex gap-1">
                <div class="w-6 h-6">
                  <Icon class="icon-stat"
                    icon-name="success-filled"
                    class-name="text-orange-600"
                    size="xs"
                  />
                </div>
                <div
                  class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                >
                  Approved Requests
                </div>
              </div>
              <div class="text-base font-bold text-jet pl-7 m-top">
                {{ totalApproved }}
              </div>
            </Card>
            <Card
              class="w-full bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
              style="box-shadow: -6px 9px 24px 0px #0000000f"
            >
              <div class="flex gap-1">
                <div class="w-6 h-6">
                  <Icon class="icon-stat"
                    icon-name="status-cancelled"
                    class-name="text-orange-600"
                    size="xs"
                  />
                </div>
                <div
                  class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                >
                  Pending Requests
                </div>
              </div>
              <div class="text-base font-bold text-jet pl-7 m-top">
                {{ totalPending }}
              </div>
            </Card>
            <Card
              class="w-full bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
              style="box-shadow: -6px 9px 24px 0px #0000000f"
            >
              <div class="flex gap-1">
                <div class="w-6 h-6">
                  <Icon class="icon-stat"
                    icon-name="cancel"
                    class-name="text-orange-600"
                    size="xs"
                  />
                </div>
                <div
                  class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                >
                  Disapproved Requests
                </div>
              </div>
              <div class="text-base font-bold text-jet pl-7 m-top">
                {{
                  totalDisapproved
                }}
              </div>
            </Card>
          </div>
        </Card>
      </div>
      <template v-slot:footer>
        <CardFooter
          module="advanceAndLoan"
          printcard
          reloadcard
          @reload="reload"
        />
      </template>
    </card>
    <card class="p-5 mt-1">
      <div class="flex-col">
        <div class="w-full">
          <div class="w-full flex flex-col">
            <Table
              v-if="requests.length > 0 || loadingData"
              :headers="consolidatedHeader"
              :items="requests"
              aria-label="consolidated table"
              :loading="loadingData"
              :has-number="false"
              class="w-full mt-4 mb-4"
              :pagination-list="metaData"
              @page="handlePage($event)"
              page-sync
              @itemsPerPage="handleItemsPerPage($event)"
            >
              <template v-slot:item="{ item }">
                <div v-if="item.paySetting" class=" capitalize">
                  {{ item.data.paySetting.nameOnPayslip }}
                </div>
                <div v-if="item.createdAt">
                  {{
                    $DATEFORMAT(new Date(item.data.createdAt), "MMMM dd, yyyy")
                  }}
                </div>
                <div v-else-if="item.principalAmount">
                  {{ convertToCurrency(item.data.principalAmount) }}
                </div>
                <div v-else-if="item.interestRate">
                  {{ `${item.data.interestRate}%` }}
                </div>
                <div v-else-if="item.interestAmount">
                  {{ convertToCurrency(item.data.interestAmount) }}
                </div>
                <div v-else-if="item.repaymentAmount">
                  {{ convertToCurrency(item.data.repaymentAmount) }}
                </div>
                <div class=" tw-text-center" v-else-if="item.repaymentDuration">
                  {{ `${item.data.repaymentDuration}` }}
                </div>
                <div
                  v-if="item.approvalStatus"
                  style="width: 100px"
                  class="p-3"
                  :class="{
                    pending: item.data.approvalStatus === 'pending',
                    approved: item.data.approvalStatus === 'approved',
                    disapproved: item.data.approvalStatus === 'disapproved'
                  }"
                >
                  <div class="w-auto capitalize flex flex-col ">
                    <p class="text-sm font-semibold ">
                      {{ item.data.approvalStatus }}
                    </p>
                  </div>
                </div>
                <div v-else-if="item.id">
                  <div
                    class="cursor-pointer flex"
                  >
                    <icon
                      icon-name="icon-eye"
                      size="xsm"
                      class="-mt-1 -ml-2 text-blueCrayola"
                      style="padding: 3px 10px; width: 36px; height: 36px;"
                    />
                  </div>
                </div>
              </template>
            </Table>
            <div
              v-else
              class="w-full flex flex-col mt-4 p-2 justify-center items-center"
            >
              <p class="text-base my-2">
                There are no pending loan requests at the moment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import CardFooter from "@/components/CardFooter";
import RightSideBar from "@/components/RightSideBar";

export default {
  name: "EssAdvance",
  components: {
    Card,
    Icon,
    CardFooter,
    RightSideBar,
    Table
  },
  data() {
    return {
      loadingData: true,
      loadingModal: false,
      metaData: {},
      itemsPerPage: 50,
      numberOfPage: 1,
      requests: [],
      totalPending: "--",
      totalApproved: "--",
      totalDisapproved: "--",
      approvedRequest: [],
      disApprovedRequest: [],
      advanceTimeline: [],
      repaymentSchedule: [],
      pendingLength: 0,
      approvedLength: 0,
      disapprovedLength: 0,
      outstandingAmount: "",
      type: "loan",
      consolidatedHeader: [
        { title: "REQUEST TYPE", value: "paySetting" },
        { title: "DATE REQUESTED", value: "createdAt" },
        { title: "PRINCIPAL AMNT.", value: "principalAmount" },
        { title: "INTEREST RATE (P/A)", value: "interestRate" },
        { title: "INTEREST AMNT", value: "interestAmount" },
        { title: "TOTAL REPAYABLE", value: "repaymentAmount" },
        { title: "REPAYMENT PERIOD", value: "repaymentDuration" },
        { title: "Status", value: "approvalStatus" },
        { title: "", value: "id", menu: true }
      ]
    };
  },
  methods: {
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },
    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },

    queryUpdate() {
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getRequests(`type=${this.type}${pageNumber}${itemPage}`);
    },

    getRequests(query) {
      this.loadingData = true;
      this.$_getEmployeeConsolidatedAdvanceAndLoan({ id: this.$AuthUser.id }).then(
        result => {
          const requestsData = result.data.data;
          this.requests = requestsData;
          this.metaData = result.data.meta;

          // TODO: get these from backend
          this.totalPending = requestsData.filter(
            request => request.approvalStatus === "pending"
          ).length;
          this.totalApproved = requestsData.filter(
            request => request.approvalStatus === "approved"
          ).length;
          this.totalDisapproved = requestsData.filter(
            request => request.approvalStatus === "disapproved"
          ).length;

          this.loadingData = false;
        }
      );
    },
    reload() {
      this.getRequests(`type=${this.type}&page=1&perPage=50`);
    },

    bgColor(data) {
      if (data === "pending") {
        return "bg-Pend";
      }

      if (data === "approved") {
        return "bg-Appr";
      }

      if (data === "disapproved") {
        return "text-desire bg-light-flame-red";
      }

      return {};
    }
  },
  computed: {
    hasSubscriptionExpired() {
      return this.$store.getters.hasSubscriptionExpired;
    }
  },
  mounted() {
      this.getRequests(`type=loan&page=1&perPage=50`);
  }
};
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  padding: 3px;
}
.bage {
  background-color: rgba(19, 181, 106, 0.15);
  color: rgba(19, 181, 106, 1);
}
.bg-Pend {
  background-color: rgba(233, 147, 35, 0.15);
  color: rgba(233, 147, 35, 1);
}
.bg-Appr {
  background-color: rgba(19, 181, 106, 0.15);
  color: rgba(19, 181, 106, 1);
}
</style>